<template>
  <div>
    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue"
      style="background-image: url('assets/img/layout/bg_head.jpg')"
    >
      <div class="popup_close close-animate" @click="$router.go(-1)">
        <a><CloseSvg /></a>
      </div>
      <a class="no_mobile link_goback cursor-p" @click="$router.go(-1)">
        חזרה
        <ArrowBackSvg
      /></a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <div class="bold">יצירת בלוק מרפאה</div>
          <div>{{ activeDoctor.name }}</div>
        </h1>
      </div>
    </section>
    <section class="add_new_main">
      <div class="add_block">
        <div class="subtitle center">
          אנא בחרו את הבלוק והתאריך הרצוי
        </div>
        <ValidationObserver ref="addNewBlock">
          <form
            @submit.prevent="submitAddBlock"
            v-promise-btn="{ action: 'submit' }"
            name="addNewBlock"
            autocomplete="off"
          >
            <div class="desk_inner_width addNewBlock">
              <div
                class="add_block_form flex flex--top flex--start split-4 mb--22"
              >
                <div class="filter_select" v-if="false">
                  <select2 v-model="blockType">
                    <option value="">שם בלוק</option>
                    <option value="surgery_catheterization_gastro_ivf">
                      ניתוח
                    </option>
                    <option value="appointment">תור</option>
                  </select2>
                </div>
                <div class="filter_select">
                  <input
                    v-if="blockNames && blockNames.length === 1"
                    :value="selectedBlockName"
                    disabled
                  />
                  <select2 v-else v-model="blockName">
                    <option value="">שם הבלוק</option>
                    <option
                      :value="block.id"
                      v-for="block in blockNames"
                      :key="block.id"
                    >
                      {{ block.name }}
                    </option>
                  </select2>
                </div>
                <div
                  class="filter_select"
                  :class="blockName && allRooms.length > 1 ? '' : 'disabled'"
                >
                  <select2
                    v-model="room"
                    :disabled="blockName && allRooms.length <= 1"
                  >
                    <option value="">חדר</option>
                    <option
                      :value="roomRow"
                      :key="index"
                      v-for="(roomRow, index) in allRooms"
                    >
                      {{ rooms_map[roomRow].name }}
                    </option>
                  </select2>
                </div>
                <div
                  class="form_input"
                  :class="{ focused: date, disabled: !room }"
                  @click="toggleVueCal"
                >
                  <input
                    class="datepicker"
                    type="text"
                    v-model="date"
                    placeholder="dd/mm/yyyy"
                    :disabled="!room"
                  />
                  <span v-if="errMsgDate" class="error-message">
                    {{ errMsgDate }}
                  </span>
                </div>
                <div
                  class="calandr_main calandr_main_add_app pop-date flex flex--column"
                  v-show="showVueCal"
                >
                  <div class="glob-date-open bg--white">
                    <a
                      @click="toggleVueCal"
                      class="restart-date flex flex--center cursor-p"
                    >
                      <img src="/assets/img/svg/close-sm-blue.svg" />
                    </a>
                    <vue-cal
                      xsmall
                      locale="he"
                      :time="false"
                      :min-date="minDate"
                      :startWeekOnSunday="true"
                      hide-view-selector
                      active-view="month"
                      :disable-views="['years', 'week', 'day']"
                      @cell-focus="onCellClick"
                      class="vuecal--green-theme vuecal--rounded-theme mini-month"
                      :events="allExistBlocks"
                      events-count-on-year-view
                      :selected-date="selectedDateCal"
                      :hide-weekdays="[6]"
                    >
                      <template v-slot:weekday-heading="{ heading }">
                        <span v-if="heading.label == 'ראשון'">א׳</span>
                        <span v-if="heading.label == 'שני'">ב׳</span>
                        <span v-if="heading.label == 'שלישי'">ג׳</span>
                        <span v-if="heading.label == 'רביעי'">ד׳</span>
                        <span v-if="heading.label == 'חמישי'">ה׳</span>
                        <span v-if="heading.label == 'שישי'">ו׳</span>
                        <span v-if="heading.label == 'שבת'">ש׳</span>
                      </template>
                      <template v-slot:events-count="{ events }">
                        <span v-if="false"> {{ countDot(events) }} </span>
                      </template>
                    </vue-cal>
                  </div>
                </div>
              </div>
              <div class="w-850">
                <div
                  class="input-width"
                  style="margin-bottom: 20px"
                  v-show="validHours.length > 0"
                >
                  <div class="subtitle center ft--300 book_hure-subt">
                    יש לבחור טווח זמן פנוי:
                  </div>
                  <div class="flex flex--content--center">
                    <a
                      class="book_hure ease"
                      :class="{ active: isActiveHour(time[0]) }"
                      style="direction: ltr"
                      href="javascript:void(0)"
                      v-for="(time, index) in validHours"
                      :key="index"
                      @click.prevent="setStartEndTime(time[0], time[1])"
                      >{{ time[0] + "-" + time[1] }}</a
                    >
                  </div>
                </div>
                <div class="hores-blockad desk-flex desk-flex--top">
                  <div
                    v-show="isHours"
                    class="input-width flex flex--top"
                    v-if="selectedDate"
                  >
                    <div
                      class="form_input form_input_with_label focused"
                      :class="{ back_focused: start_time_value }"
                    >
                      <label>שעת התחלה*</label>
                      <validation-provider
                        name="start_time"
                        :rules="{
                          required: true,
                          timeFormat: [end_time_value],
                          interval: [end_time_value],
                          min: start_time,
                          isSmallest: [end_time_value]
                        }"
                        v-slot="{ errors }"
                      >
                        <!-- <vue-timepicker
                          name="start_time"
                          manual-input
                          hide-dropdown
                          :minute-interval="5"
                          v-model="start_time_value"
                        ></vue-timepicker> -->
                        <cleave
                          :value="start_time_value"
                          :options="options"
                          @input="onCleave('start_time_value', $event)"
                          @focus.native="e => e.target.select()"
                          name="start_time"
                        ></cleave>
                        <span class="error-message">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div
                      class="form_input form_input_with_label focused"
                      :class="{ focused: end_time_value }"
                    >
                      <label>שעת סיום*</label>
                      <validation-provider
                        name="end_time"
                        :rules="{
                          required: true,
                          timeFormat: [start_time_value],
                          interval: [start_time_value],
                          isBigger: [start_time_value],
                          max: [end_time, date]
                        }"
                        v-slot="{ errors }"
                      >
                        <!-- <vue-timepicker
                          name="end_time"
                          manual-input
                          hide-dropdown
                          :minute-interval="5"
                          v-model="end_time_value"
                        ></vue-timepicker> -->
                        <cleave
                          :value="end_time_value"
                          :options="options"
                          name="end_time"
                          @input="onCleave('end_time_value', $event)"
                          @focus.native="e => e.target.select()"
                        ></cleave>
                        <span class="error-message">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div v-show="isHours && selectedDate" class="filter_select">
                    <select2 v-model="block_repeat">
                      <option value="">בחרו חזרות</option>
                      <option value="no_repeat">ללא חזרה</option>
                      <option value="weekly_1">פעם בשבוע</option>
                      <option value="weekly_2">פעם בשבועיים</option></select2
                    >
                    <span v-if="errRepeat" class="error-message">
                      {{ errRepeat }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form_submit center" :class="{ bt_disable: !isValid }">
                <input type="submit" value="שמירה" />
              </div>
            </div>
            <div class="server-message mobile_only" v-if="serverMessage">
              {{ serverMessage }}
            </div>
          </form>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.es.js";
import "vue-cal/dist/vuecal.css";
import CloseSvg from "@/assets/img/svg/close.svg";
import ConfirmNewBlock from "@/components/Popups/ConfirmNewBlock";
import Error from "@/components/Popups/Error";
import ArrowBackSvg from "@/assets/img/svg/arrow_r.svg";
import Cleave from "vue-cleave-component";

var indicator = document.createElement("div");
indicator.className = "state-indicator";
document.body.appendChild(indicator);

export default {
  name: "AddBlock",
  components: {
    VueCal,
    CloseSvg,
    ArrowBackSvg,
    Cleave
  },
  data: function() {
    return {
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      selectedDateCal: new Date(),
      showVueCal: false,
      allExistBlocks: [],
      page_loaded: false,
      blockType: "appointment",
      blockTypes: [],
      blockName: "",
      blockNames: [],
      start_time: "",
      start_time_value: "",
      end_time: "",
      end_time_value: "",
      date: "",
      room: "",
      events: [],
      blocks: [],
      allRooms: [],
      filteredBlocks: [],
      notAvailableBlock: {},
      activeDates: [],
      selectedDate: "",
      validHours: [],
      serverMessage: "",
      block_repeat: "",
      isHours: false,
      showTimeInputs: false,
      errRepeat: null,
      selectedBlockName: null,
      errMsgDate: null
    };
  },
  mounted() {
    var _this = this;
    this.$API
      .getDoctorBlockTypes(this.activeDoctor.id, "appointment")
      .then(res => {
        this.blockNames = res.data;
        this.blockName = this.blockNames[0].id;
        this.selectedBlockName = this.blockNames[0].name;
        // if (this.blockNames.length === 1) this.blockName = this.blockNames[0].id;
      });
  },
  computed: {
    ...mapState({
      rooms_map: "allRooms"
    }),
    ...mapGetters(["activeDoctor", "activeUser"]),
    repeatedDates() {
      if (this.room && this.selectedDate) {
        let room_number = this.room.split("_")[1];
        let arr = new Array();
        if (this.block_repeat == "weekly_1") {
          let start_date = this.selectedDate;
          //arr.push(start_date + "_" + start_date);
          let dateObject = this.$moment(start_date);
          let dateEnd = this.$moment(start_date).add("3", "y");
          while (!dateObject.isSameOrAfter(dateEnd)) {
            let parsedDate = dateObject.format("-MM-DD");
            let tmp = parsedDate + "_" + room_number;
            arr.push(tmp);
            dateObject.add("1", "w");
          }
          return arr.join(",");
        }
        if (this.block_repeat == "weekly_2") {
          let start_date = this.selectedDate;
          //arr.push(start_date + "_" + start_date);
          let dateObject = this.$moment(start_date);
          let dateEnd = this.$moment(start_date).add("3", "y");
          while (!dateObject.isSameOrAfter(dateEnd)) {
            let parsedDate = dateObject.format("YYYY-MM-DD");
            let tmp = parsedDate + "_" + room_number;
            arr.push(tmp);
            dateObject.add("2", "w");
          }
          return arr.join(",");
        }
        return "";
      }
      return "";
    },
    isValid() {
      if (this.room && this.selectedDate && this.end_time && this.start_time) {
        return true;
      }
      return false;
    },
    roomInto() {
      let room, room_id;
      if (this.room) {
        room_id = this.room;
        room = this.rooms_map[room_id];
      }
      return room;
    },
    minDate() {
      return new Date();
    }
  },
  watch: {
    blockType(value) {
      this.$API
        .getDoctorBlockTypes(this.activeDoctor.id, value)
        .then(res => {
          this.blockNames = res.data;
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    },
    blockName(value) {
      if (value) {
        this.room = "";
        this.date = "";
        this.validHours = [];
        let from_date = this.$moment().format("YYYY-MM-DD");
        let to_date = this.$moment()
          .add(3, "M")
          .format("YYYY-MM-DD");
        this.$API
          .getBlockMaps(
            this.activeUser.user_id,
            this.activeDoctor.id,
            from_date,
            to_date
          )
          .then(res => {
            // filter app type
            let allblocktype = res.filter(
              block => block.type == this.blockType
            );
            if (typeof allblocktype != "undefined") {
              this.blocks = allblocktype;

              allblocktype.map(block => {
                if (this.allRooms.indexOf(block.room) < 0) {
                  this.allRooms.push(block.room);
                }
              });

              if (this.allRooms.length == 1) {
                this.room = this.allRooms[0];
              }
            }
          });
      }
    },
    room(value) {
      this.date = "";
      this.validHours = [];
      let arr = [];
      arr = this.blocks.filter(room => room.room == this.room);
      this.filteredBlocks = arr;
      this.getBlocks();
      let blocked_blocks = {};
      arr.map(block => {
        let start_time = this.$moment(block.start_datetime).format("HH:mm");
        let end_time = this.$moment(block.end_datetime).format("HH:mm");
        let date = this.$moment(block.start_datetime).format("YYYY-MM-DD");
        let object = {
          start: start_time,
          end: end_time
        };

        if (typeof blocked_blocks[date] == "undefined") {
          Object.assign(blocked_blocks, { [date]: [] });
        }
        blocked_blocks[date].push(object);
      });
      this.notAvailableBlock = blocked_blocks;
    },
    selectedDate(value) {
      this.errMsgDate = null;
      this.start_time_value = "";
      this.end_time_value = "";
      let invalidTimes = this.notAvailableBlock[value];
      const day = this.$moment(value, "YYYY-MM-DD").day();
      // const weekdays = this.roomInto.constraints.days.weekdays;
      // const friday = this.roomInto.constraints.days.friday;

      // var tomorow = this.$moment(value, "YYYY-MM-DD").add(1, "day");
      let times_arr = [];
      let time_start = this.$moment(value + "T" + "08:00", "YYYY-MM-DDTLTS");

      let time_limit;
      if (day == 5) {
        time_limit = this.$moment(value + "T" + "15:00", "YYYY-MM-DDTLTS");
      } else {
        time_limit = this.$moment(value + "T" + "21:00", "YYYY-MM-DDTLTS");
      }

      for (const key in invalidTimes) {
        let time = invalidTimes[key];
        let time_moment = this.$moment(
          value + "T" + time.start,
          "YYYY-MM-DDTLT"
        );
        if (
          time_start < time_moment &&
          Math.abs(time_start.diff(time_moment, "hours")) >= 2
        ) {
          let tmp = [time_start.format("LT"), time_moment.format("LT")];
          times_arr.push(tmp);
        }
        time_start = this.$moment(value + "T" + time.end, "YYYY-MM-DDTLT");
        if (time_start.isAfter(time_limit)) {
          time_start = time_limit;
        }
      }
      if (time_start < time_limit) {
        let tmp = [time_start.format("LT"), time_limit.format("LT")];
        times_arr.push(tmp);
      }
      if (!times_arr || !times_arr.length)
        this.errMsgDate = "בתאריך זה לא ניתן ליצור בלוק חדש";
      this.validHours = times_arr;
    },
    block_repeat(val) {
      if (val) this.errRepeat = null;
    }
  },
  methods: {
    async submitAddBlock(value) {
      const validate = await this.$refs.addNewBlock.validate();
      if (!this.block_repeat) return (this.errRepeat = "שדה חובה");
      if (!validate) return;
      this.isHours = false;
      return new Promise((resolve, reject) => {
        let block_name = this.blockNames.find(
          block => block.id == this.blockName
        );
        let new_block = {
          type_id: block_name.id,
          room: this.room,
          start: this.selectedDate + "T" + this.start_time_value + ":00",
          end: this.selectedDate + "T" + this.end_time_value + ":00",
          true_id: "-",
          title: block_name.name
        };
        this.$API
          .saveNewBlock(new_block)
          .then(res => {
            if (res.status == "OK") {
              if (this.repeatedDates) {
                this.$API
                  .duplicateBlock(res.block_id, this.repeatedDates)
                  .then(res => {
                    if (res.status == "OK") {
                      this.blockName = "";
                      this.room = "";
                      this.selectedDate = "";
                      this.end_time_value = "";
                      this.start_time_value = "";
                      resolve(true);
                    }
                  });
              }
              this.$modal.show(ConfirmNewBlock, { date: this.selectedDate });
              this.blockName = "";
              this.room = "";
              this.selectedDate = "";
              this.end_time_value = "";
              this.start_time_value = "";
              this.selectedDate = "";
              this.showTimeInputs = false;
              resolve(true);
            } else {
              this.serverMessage = res.message;
              resolve(true);
            }
          })
          .catch(e => {
            this.$modal.show(Error);
          });
      });
    },
    setStartEndTime(start, end) {
      if (this.start_time === start && this.end_time === end) {
        this.isHours = false;
        this.start_time = "";
        this.end_time = "";
        this.start_time_value = "";
        this.end_time_value = "";
        this.showTimeInputs = false;
      } else {
        this.isHours = true;
        this.start_time = start;
        this.end_time = end;
        this.start_time_value = start;
        this.end_time_value = end;
        this.showTimeInputs = true;
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: "smooth"
          });
        }, 200);
      }
    },
    isActiveHour(start) {
      if (this.start_time_value === start) return true;
      else return false;
    },
    toggleVueCal() {
      if (!this.room) return;
      this.showVueCal = !this.showVueCal;
    },
    getBlocks() {
      let startdate = this.$moment().format("YYYY-MM-DDTHH:mm");
      let endtdate = this.$moment(startdate, "YYYY-MM-DDTHH:mm")
        .add("1", "y")
        .format("YYYY-MM-DDTHH:mm");
      this.$API
        .getFullCalendarEvents(
          this.activeUser.user_id,
          this.activeDoctor.id,
          "appointment",
          startdate,
          endtdate
        )
        .then(events => {
          if (events) {
            this.allExistBlocks = [];
            events.map((block, index) => {
              if (
                typeof block.appointment_id != "undefined" ||
                typeof block.surgery_id != "undefined" ||
                block.resourceId !== this.room
              ) {
                return;
              }
              let tmp = {
                start: new Date(block.start), // Required.
                end: new Date(block.end), // Required.
                date: this.$moment(new Date(block.start)).format("DD/MM/YYYY"), // Required.
                id: block.background_block_id,
                type: "block"
              };

              this.allExistBlocks.push(tmp);
            });
          }
        });
    },
    onCellClick(ev) {
      this.date = this.$moment(ev).format("DD/MM/YYYY");
      this.selectedDate = this.$moment(ev).format("YYYY-MM-DD");
      this.showVueCal = false;
    },
    onCleave(type, ev) {
      if (ev) {
        this[type] = ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
      } else {
        this[type] = ev;
      }
    }
  }
};
</script>
